<footer class="hidden md:block bg-faunago-dark text-white/70 text-sm py-6 mt-auto">
  <div class="container mx-auto px-8 flex flex-col md:flex-row items-center justify-between gap-3">
    <p>
      <span class="font-medium text-white">FaunaGo</span> este un proiect susținut de
      <img src="cercetasii-icon.png" alt="Cercetașii României" class="inline-block h-5 w-5 align-text-bottom"> 
      <a href="https://albascout.ro" target="_blank" rel="noopener noreferrer" class="text-faunago-yellow font-medium hover:text-white transition-colors"> Cercetașii României Alba Iulia</a>
    </p>
    <div class="flex items-center gap-4 text-xs">
      <a routerLink="/despre" class="hover:text-white transition-colors">Despre proiect</a>
      <span class="text-white/30">|</span>
      <a routerLink="/confidentialitate" class="hover:text-white transition-colors">Confidențialitate</a>
      <span class="text-white/30">|</span>
      <a routerLink="/termeni" class="hover:text-white transition-colors">Termeni și Condiții</a>
    </div>
  </div>
</footer>